/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import cognito from './cognito'
import api from './api'
import confirm from './confirm'

new Vue({
  router,
  store,
  cognito,
  api,
  confirm,
  render: h => h(App)
}).$mount('#app')
/* eslint-enable */